import * as React from 'react';

import { MultiProductDateForm } from 'components/MultiProductDateForm/MultiProductDateForm';

export const EmbeddedMultiProductCalendar = () => {
  return <MultiProductDateForm />;
};
